var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-quick-access"},[_c('card-quick-links'),_vm._v(" "),_c('card-daily-routine')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }